import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CacheConstant } from '../../../core/constants/app.constant';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { SusbscribedItemDetails } from '../../../shared/models/product';

@Component({
  selector: 'par-inventory-alert',
  templateUrl: './inventory-alert.component.html',
  styleUrls: ['./inventory-alert.component.scss']
})
export class InventoryAlertComponent implements OnInit {
  /***************Properties***************/
  lowQuantityProductIds: string = null;
  excludedProductIds: string = null;
  outOfStockProductIds: string = null;
  invalidSubscriptionIds: string = null;
  websiteName = this.cache.get(CacheConstant.Env_Properties).theme;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    public dialogRef: MatDialogRef<InventoryAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cache: AppCacheService
  ) { }

  ngOnInit() {
    if (
      this.data.lowQuantityProducts &&
      this.data.lowQuantityProducts.length > 0
    ) {
      this.lowQuantityProductIds = this.getProductIds(
        this.data.lowQuantityProducts
      ).join(', ');
    }

    if (this.data.excludedProducts && this.data.excludedProducts.length > 0) {
      this.excludedProductIds = this.getProductIds(
        this.data.excludedProducts
      ).join(', ');
    }

    if (
      this.data.outOfStockProducts &&
      this.data.outOfStockProducts.length > 0
    ) {
      this.outOfStockProductIds = this.getProductIds(
        this.data.outOfStockProducts
      ).join(', ');
    }

    if (
      this.data.invalidSubscribedItem &&
      this.data.invalidSubscribedItem.length > 0
    ) {
      this.invalidSubscriptionIds = this.getItemIds(
        this.data.invalidSubscribedItem
      ).join(', ');
    }
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onClose() {
    this.dialogRef.close();
  }

  /***************Component Methods***************/

  /***************Private Methods***************/

  private getProductIds(products: Array<any>) {
    const ids = [];

    products.forEach(product => {
      if (!ids.includes(product.itemId)) {
        ids.push(product.itemId);
      }
    });

    return ids;
  }

  private getItemIds(subscribedItemDetails: SusbscribedItemDetails[]) {

    const itemIds = [];
    subscribedItemDetails.forEach(product => {
      if (!itemIds.includes(product.itemId)) {
        itemIds.push(product.itemId);
      }
    });

    return itemIds;
  }

  /***************Private Methods***************/
}
